import React from 'react';
import { FaTrashAlt, FaCamera } from 'react-icons/fa';
import './styles/ClockOut.css';

const ClockOut = ({ onClose }) => {
  return (
    <div className="clockout-overlay">
      <div className="clockout-box">
        <h2 className="title">Clock Out</h2>
        <h3 className="subtitle">Wrap up your shift</h3>

        {/* Date and Time */}
        <div className="row">
          <label className="input-label" htmlFor="date">
            Date and Time
          </label>
          <div className="input-group date-time-group">
            <div className="input-with-icon">
              <input type="date" id="date" />

            </div>
            <div className="input-with-icon time-input">
              <input type="time" />
            </div>
          </div>
        </div>

        {/* Add Before Picture */}
        <div className="row">
          <label className="input-label">Add After Picture</label>
          <div className="upload-container">
            <label className="upload-box">
              <FaCamera className="upload-icon" />
              <p>Upload file here</p>
              <input type="file" hidden />
            </label>
            <div className="delete-icon-container">
              <FaTrashAlt className="delete-icon" />
            </div>
          </div>
        </div>

        {/* Note */}
        <div className="row">
          <label className="input-label">Note</label>
          <textarea
            placeholder="Type here......"
            className="textarea"
          ></textarea>
        </div>

        {/* Buttons */}
        <button className="btn-primary">Clock Out</button>
        <button className="btn-cancel" onClick={onClose}>
          cancel
        </button>
      </div>
    </div>
  );
};

export default ClockOut;
